import { useEffect, useState } from 'react'
import InfiniteScroll from 'react-infinite-scroller'
import LoadingDots from '../LoadingDots'

export default function InfiniteScrollComponent({
  component,
  total,
  fetchData,
  currentNumber,
  useWindow = true,
}: any) {
  const [hasMore, setHasMore] = useState(false)

  useEffect(() => {
    setHasMore(currentNumber < total)
  }, [currentNumber])

  return currentNumber < 1 ? (
    <div className="py-5 text-center">
      <LoadingDots />
    </div>
  ) : (
    <InfiniteScroll
      pageStart={0}
      loadMore={fetchData}
      hasMore={hasMore}
      threshold={6000}
      useWindow={useWindow}
      initialLoad={false}
      loader={
        <div className="py-5 text-center" key="infinite-scroll-loader">
          <LoadingDots />
        </div>
      }

      // dataLength={total} //This is important field to render the next data
      // next={fetchData}
      // hasMore={hasMore}
      // scrollThreshold={scrollThreshold ? scrollThreshold : 0.8}   // 0.8 is the deafult value for scroll threshold.

      // endMessage={
      //   <p className="py-5" style={{ textAlign: 'center' }}>
      //     <b>You have seen it all</b>
      //   </p>
      // }
    >
      <div key="infinite-scroll">{component}</div>
    </InfiniteScroll>
  )
}
